import { useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import { SidebarProvider, useSidebar } from "../context/SidebarContext";
// import { KnowledgeBaseProvider } from "../context/KnowledgeBaseContext";
// import { AgentProvider } from "../context/AgentContext";

const DASHBOARD_TRACKED_KEY = "gtag_dashboard_tracked";

const MainlayoutContent = () => {
  const { isOpen } = useSidebar();

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", flexDirection: "column" }}>
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <Sidebar />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            marginLeft: { xs: 0, md: isOpen ? "280px" : "72px" },
            transition: "margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            minHeight: "100vh",
            width: {
              xs: "100%",
              md: isOpen ? "calc(100vw - 280px)" : "calc(100vw - 72px)",
            },
          }}
        >
          <Container
            component="main"
            maxWidth={false}
            sx={{
              flexGrow: 1,
              padding: { xs: 2, sm: 3, md: 4 },
              overflow: "auto",
              backgroundColor: "#f8fafc",
              minHeight: "100vh",
              position: "relative",
              "&::before": {
                content: '""',
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  'url("data:image/svg+xml,%3Csvg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z" fill="%23667eea" fill-opacity="0.02" fill-rule="evenodd"/%3E%3C/svg%3E")',
                pointerEvents: "none",
                zIndex: 0,
              },
            }}
          >
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Outlet />
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

const Mainlayout = () => {
  // Track "reached dashboard" once per session for Google Ads / Analytics
  useEffect(() => {
    if (typeof window === "undefined" || !window.gtag) return;
    if (sessionStorage.getItem(DASHBOARD_TRACKED_KEY)) return;
    sessionStorage.setItem(DASHBOARD_TRACKED_KEY, "1");
    window.gtag("event", "login", { method: "email" });
    window.gtag("event", "reached_dashboard");
  }, []);

  return (
    <SidebarProvider>
      {/* <KnowledgeBaseProvider> */}
      {/* <AgentProvider> */}
      <MainlayoutContent />
      {/* </AgentProvider> */}
      {/* </KnowledgeBaseProvider> */}
    </SidebarProvider>
  );
};

export default Mainlayout;
